module.exports = __webpack_public_path__ + "static/media/15.6af63423.png";